import { useState, useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const Gallery = () => {
  const [activeFilter, setActiveFilter] = useState('all');
  const [activeSection, setActiveSection] = useState('photos');
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);

  const filters = [
    { id: 'all', label: 'Tous' },
    { id: 'pavillon-afrique', label: 'Pavillon Afrique' },
    { id: 'festival-afverso', label: 'Festival Afroverso' },
    { id: 'popup-stores', label: 'Pop-up Stores' },
    { id: 'ateliers', label: 'Ateliers & Workshops' },
    { id: 'evenements-culturels', label: 'Événements Culturels' }
  ];

  const sections = [
    { id: 'photos', label: 'Photos', icon: 'ri-image-line' },
    { id: 'videos', label: 'Vidéos & Teasers', icon: 'ri-video-line' },
    { id: 'testimonials', label: 'Témoignages', icon: 'ri-chat-quote-line' },
    { id: 'social', label: 'Réseaux Sociaux', icon: 'ri-share-line' }
  ];

  const photos = [
    {
      id: 9,
      src: 'https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Afrovidedressing/Lewing%201.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJBZnJvdmlkZWRyZXNzaW5nL0xld2luZyAxLmpwZyIsImlhdCI6MTc2MjUyNTEyOCwiZXhwIjoxNzk0MDYxMTI4fQ.ovjs8BjMcIPUzS-3NjagfLzP4ar6cb-tJpZG8JF9Cpk',
      alt: 'Événement Lewing - Mode africaine',
      category: 'evenements-culturels',
      title: 'Événement Lewing',
      description: 'Présentation mode et rencontre culturelle'
    },
    {
      id: 10,
      src: 'https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Afrovidedressing/ivoirien%20micro.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJBZnJvdmlkZWRyZXNzaW5nL2l2b2lyaWVuIG1pY3JvLmpwZyIsImlhdCI6MTc2MjUyNTIyOCwiZXhwIjoxNzk0MDYxMjI4fQ.0OJ7BIOkCzjyIiaOQcAQI-qvCa1qxWtA7eBsY-ejnWw',
      alt: 'Intervention ivoirienne - Micro ouvert',
      category: 'evenements-culturels',
      title: 'Intervention Ivoirienne',
      description: 'Prise de parole et échange culturel'
    },
    {
      id: 11,
      src: 'https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Afrovidedressing/Roro.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJBZnJvdmlkZWRyZXNzaW5nL1Jvcm8uanBnIiwiaWF0IjoxNzYyNTI1MzA5LCJleHAiOjE3OTQwNjEzMDl9.93b2hT5bZJhqzP0bZzSwjWhWBT1rsfn2eGyEHnUDRwI',
      alt: 'Événement Roro - Rencontre culturelle',
      category: 'evenements-culturels',
      title: 'Événement Roro',
      description: 'Moment d\'échange et de partage culturel'
    },
    {
      id: 12,
      src: 'https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Afrovidedressing/534A1917.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJBZnJvdmlkZWRyZXNzaW5nLzUzNEExOTE3LmpwZyIsImlhdCI6MTc2MjUyNTQwNSwiZXhwIjoxNzk0MDYxNDA1fQ.Sy57i1QSvQFbpTNckGffZMDjBOturnOaHKsziDr-LSE',
      alt: 'Événement culturel - Moment de convivialité',
      category: 'evenements-culturels',
      title: 'Moment Convivial',
      description: 'Échange et partage dans une ambiance chaleureuse'
    },
    {
      id: 13,
      src: 'https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Afrovidedressing/534A1907.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJBZnJvdmlkZWRyZXNzaW5nLzUzNEExOTA3LmpwZyIsImlhdCI6MTc2MjUyNTUwNCwiZXhwIjoxNzk0MDYxNTA0fQ.8CSp4diycCosDgGHgfCU3XzoKm0bUFWgR5QgxMwOoiM',
      alt: 'Événement culturel - Rencontre communautaire',
      category: 'evenements-culturels',
      title: 'Rencontre Communautaire',
      description: 'Rassemblement et célébration de la diversité culturelle'
    },
    {
      id: 14,
      src: 'https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Afrovidedressing/dipita.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJBZnJvdmlkZWRyZXNzaW5nL2RpcGl0YS5qcGciLCJpYXQiOjE3NjI1MjU2MDQsImV4cCI6MTc5NDA2MTYwNH0.EYQMgblfzAcht0rhovHfjRdY6aQeZNGuyXLVNMkdQiY',
      alt: 'Événement Dipita - Rencontre culturelle',
      category: 'evenements-culturels',
      title: 'Événement Dipita',
      description: 'Moment de partage et d\'échange interculturel'
    },
    {
      id: 15,
      src: 'https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Afrovidedressing/sweety.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJBZnJvdmlkZWRyZXNzaW5nL3N3ZWV0eS5qcGciLCJpYXQiOjE3NjI1MjU3MDcsImV4cCI6MTc5NDA2MTcwN30.1UdBHrz2Xe1J7IapKJKW_vpEYmwarncXyOTYtq0Nb6M',
      alt: 'Événement Sweety - Moment culturel',
      category: 'evenements-culturels',
      title: 'Événement Sweety',
      description: 'Célébration et partage dans la joie et la convivialité'
    },
    {
      id: 16,
      src: 'https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Afrovidedressing/maroc%20micro.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJBZnJvdmlkZWRyZXNzaW5nL21hcm9jIG1pY3JvLmpwZyIsImlhdCI6MTc2MjUyNTgzMSwiZXhwIjoxNzk0MDYxODMxfQ.O_FUL1VbKUMEKIKnWYkR4YK2gOrN6VAxJ_vQimT2pPc',
      alt: 'Intervention marocaine - Micro ouvert',
      category: 'evenements-culturels',
      title: 'Intervention Marocaine',
      description: 'Prise de parole et échange culturel marocain'
    },
    {
      id: 17,
      src: 'https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Afrovidedressing/Sabrina%20micro.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJBZnJvdmlkZWRyZXNzaW5nL1NhYnJpbmEgbWljcm8uanBnIiwiaWF0IjoxNzYyNTI2MTUzLCJleHAiOjE3OTQwNjIxNTN9.mO5WneUEIsP2FEREsH1GADksII-UccCcXvYCGlseGVA',
      alt: 'Intervention Sabrina - Micro ouvert',
      category: 'evenements-culturels',
      title: 'Intervention Sabrina',
      description: 'Prise de parole et échange culturel'
    },
    {
      id: 18,
      src: 'https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Afrovidedressing/Edw.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJBZnJvdmlkZWRyZXNzaW5nL0Vkdy5qcGciLCJpYXQiOjE3NjI1MjYyODQsImV4cCI6MTc5NDA2MjI4NH0.cT-ahlCOKBZ5PzAnluE7fg092b81_RVsieJSNs0d6ng',
      alt: 'Événement Edw - Rencontre culturelle',
      category: 'evenements-culturels',
      title: 'Événement Edw',
      description: 'Moment d\'échange et de partage interculturel'
    },
    {
      id: 19,
      src: 'https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Afrovidedressing/Achats%201.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJBZnJvdmlkZWRyZXNzaW5nL0FjaGF0cyAxLmpwZyIsImlhdCI6MTc2MjUyNjQzNywiZXhwIjoxNzk0MDYyNDM3fQ.GLjobIIzwYV2wWwyHaUmJJTKfiOfxRW-Y-cR1rwbEB8',
      alt: 'Pavillon Afrique - Achats',
      category: 'evenements-culturels',
      title: 'Pavillon Afrique',
      description: 'Découverte et achat de produits africains authentiques'
    },
    {
      id: 20,
      src: 'https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Afrovidedressing/Maddakar.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJBZnJvdmlkZWRyZXNzaW5nL01hZGRha2FyLmpwZyIsImlhdCI6MTc2MjUyNjU4NywiZXhwIjoxNzk0MDYyNTg3fQ.SMOBlGHAqtD-8W1vdlhogRMFkAB0qI9iZdfDSmY5H00',
      alt: 'Événement Maddakar - Rencontre culturelle',
      category: 'evenements-culturels',
      title: 'Événement Maddakar',
      description: 'Moment de partage et d\'échange interculturel'
    },
    {
      id: 21,
      src: 'https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Afrovidedressing/Rhum.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJBZnJvdmlkZWRyZXNzaW5nL1JodW0uanBnIiwiaWF0IjoxNzYyNTI2ODA5LCJleHAiOjE3OTQwNjI4MDl9.fXcSgKjnuINwCpJrjcYNqWPF0NH55jaJ3ghLmrn6Fis',
      alt: 'Événement Rhum - Rencontre culturelle',
      category: 'evenements-culturels',
      title: 'Événement Rhum',
      description: 'Moment de convivialité et d\'échange interculturel'
    },
    {
      id: 22,
      src: 'https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Afrovidedressing/SAM.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJBZnJvdmlkZWRyZXNzaW5nL1NBTS5qcGciLCJpYXQiOjE3NjI1MjY5ODMsImV4cCI6MTc5NDA2Mjk4M30.IEvH7UUZEp0VFHErMBDvXaAXDXavimKYQEdCmfNuRO8',
      alt: 'Événement SAM - Rencontre culturelle',
      category: 'evenements-culturels',
      title: 'Événement SAM',
      description: 'Moment de partage et d\'échange interculturel'
    },
    {
      id: 23,
      src: 'https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Afrovidedressing/mai%20micro.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJBZnJvdmlkZWRyZXNzaW5nL21haSBtaWNyby5qcGciLCJpYXQiOjE3NjI1MjcyMjEsImV4cCI6MTc5NDA2MzIyMX0.-z6TWdKLNZv05dziEVACJUW8IfkLrjqfA3DH1_gpo6s',
      alt: 'Intervention Mai - Micro ouvert',
      category: 'evenements-culturels',
      title: 'Intervention Mai',
      description: 'Prise de parole et échange culturel'
    },
    {
      id: 24,
      src: 'https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Afrovidedressing/Stand%20Rhum.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJBZnJvdmlkZWRyZXNzaW5nL1N0YW5kIFJodW0uanBnIiwiaWF0IjoxNzYyNTI3Mzk4LCJleHAiOjE3OTQwNjMzOTh9.wYX6dBc1pFa4rMNhZHetWVlz-PqGwBENszbR-UVfj8U',
      alt: 'Stand Rhum - Exposition culturelle',
      category: 'evenements-culturels',
      title: 'Stand Rhum',
      description: 'Stand d\'exposition et présentation culturelle'
    }
  ];

  const videos = [
    {
      id: 1,
      title: 'Pavillon Afrique 2024 - Teaser Officiel',
      duration: '2:15',
      thumbnail: 'https://public.readdy.ai/ai/img_res/efdfb74e681fc681d7b588e6fdd28bb9.jpg',
      category: 'pavillon-afrique',
      videoUrl: 'https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Teasing%20video/9e201229-2b75-4467-ab50-bf69c2799c3f.MP4?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJUZWFzaW5nIHZpZGVvLzllMjAxMjI5LTJiNzUtNDQ2Ny1hYjUwLWJmNjljMjc5OWMzZi5NUDQiLCJpYXQiOjE3NjIyNzQwMDEsImV4cCI6MTc5MzgxMDAwMX0.gHHWwe1-O5UA_Bx08OXaiv_b7sKkoRvJd7tdNfLNg8A'
    },
    {
      id: 2,
      title: 'Concert Événement Culturel',
      duration: '3:45',
      thumbnail: 'https://readdy.ai/api/search-image?query=African%20cultural%20concert%20video%20thumbnail%2C%20live%20music%20performance%2C%20vibrant%20stage%20lighting%2C%20audience%20enjoying%20african%20music%2C%20professional%20concert%20videography%20style%2C%20warm%20colors&width=320&height=180&seq=video2&orientation=landscape',
      category: 'evenements-culturels',
      videoUrl: 'https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Concert%201/Concert%201.mp4?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJDb25jZXJ0IDEvQ29uY2VydCAxLm1wNCIsImlhdCI6MTc2MjUyMjQwMCwiZXhwIjoxNzk0MDU4NDAwfQ.DM-cggOkx2gXQFlDi26TAwCLK0eYGXxr3nk4ho5Mnmo'
    },
    {
      id: 3,
      title: 'Festival Afroverso - Afrovidedressing',
      duration: '2:30',
      thumbnail: 'https://readdy.ai/api/search-image?query=African%20sustainable%20fashion%20video%20thumbnail%2C%20Festival%20Afroverso%20event%2C%20circular%20fashion%20market%2C%20colorful%20african%20clothing%2C%20eco-friendly%20fashion%20showcase%2C%20professional%20event%20videography%20style&width=320&height=180&seq=video3&orientation=landscape',
      category: 'festival-afverso',
      videoUrl: 'https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Afrovidedressing%20video/WhatsApp%20Video%202025-11-10%20at%2014.11.49.mp4?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJBZnJvdmlkZWRyZXNzaW5nIHZpZGVvL1doYXRzQXBwIFZpZGVvIDIwMjUtMTEtMTAgYXQgMTQuMTEuNDkubXA0IiwiaWF0IjoxNzYyODAyOTg0LCJleHAiOjE3OTQzMzg5ODR9.w612eRa5RnRRYRjCxZcrFxYwckBNc_tN1VXuQjJxQHw'
    }
  ];

  const testimonials = [
    {
      id: 1,
      name: 'Aminata Diallo',
      role: 'Créatrice de mode',
      content: 'Ideevents nous a permis de présenter notre collection dans un cadre exceptionnel. L\'organisation était parfaite !',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20African%20female%20fashion%20designer%2C%20confident%20smile%2C%20modern%20studio%20setting%2C%20professional%20headshot%20photography%2C%20clean%20neutral%20background&width=80&height=80&seq=testimonial1&orientation=squarish'
    },
    {
      id: 2,
      name: 'Kofi Asante',
      role: 'Artiste plasticien',
      content: 'Le Festival Afroverso a été une vitrine formidable pour mon art. Merci à toute l\'équipe d\'Ideevents !',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20African%20male%20artist%2C%20creative%20personality%2C%20art%20studio%20background%2C%20professional%20headshot%20photography%2C%20clean%20artistic%20background&width=80&height=80&seq=testimonial2&orientation=squarish'
    },
    {
      id: 3,
      name: 'Fatou Sow',
      role: 'Entrepreneure',
      content: 'Grâce au pop-up store organisé par Ideevents, j\'ai pu faire connaître ma marque à un nouveau public.',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20African%20female%20entrepreneur%2C%20business%20attire%2C%20confident%20expression%2C%20modern%20office%20setting%2C%20professional%20headshot%20photography%2C%20clean%20business%20background&width=80&height=80&seq=testimonial3&orientation=squarish'
    }
  ];

  const filteredPhotos = activeFilter === 'all' 
    ? photos 
    : photos.filter(photo => photo.category === activeFilter);

  const filteredVideos = activeFilter === 'all' 
    ? videos 
    : videos.filter(video => video.category === activeFilter);

  // Slideshow functionality
  useEffect(() => {
    if (isPlaying && filteredPhotos.length > 0) {
      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % filteredPhotos.length);
      }, 4000); // Change slide every 4 seconds

      return () => clearInterval(interval);
    }
  }, [isPlaying, filteredPhotos.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % filteredPhotos.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + filteredPhotos.length) % filteredPhotos.length);
  };

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-orange-500 to-red-500 text-white py-20">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl font-bold mb-6">Galerie & Médias</h1>
            <p className="text-xl opacity-90">
              Découvrez nos événements à travers photos, vidéos et témoignages
            </p>
          </div>
        </div>
      </section>

      {/* Navigation Sections */}
      <section className="py-8 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="flex flex-wrap justify-center gap-4">
            {sections.map((section) => (
              <button
                key={section.id}
                onClick={() => setActiveSection(section.id)}
                className={`flex items-center gap-2 px-6 py-3 rounded-full transition-all whitespace-nowrap cursor-pointer ${
                  activeSection === section.id
                    ? 'bg-orange-500 text-white'
                    : 'bg-white text-gray-700 hover:bg-orange-100'
                }`}
              >
                <i className={`${section.icon} text-lg`}></i>
                {section.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Filters only */}
      {(activeSection === 'photos' || activeSection === 'videos') && (
        <section className="py-6 bg-white border-b">
          <div className="container mx-auto px-6">
            <div className="flex justify-center">
              {/* Filters */}
              <div className="flex flex-wrap justify-center gap-3">
                {filters.map((filter) => (
                  <button
                    key={filter.id}
                    onClick={() => setActiveFilter(filter.id)}
                    className={`px-4 py-2 rounded-full text-sm transition-all whitespace-nowrap cursor-pointer ${
                      activeFilter === filter.id
                        ? 'bg-orange-500 text-white'
                        : 'bg-gray-100 text-gray-700 hover:bg-orange-100'
                    }`}
                  >
                    {filter.label}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Content Sections */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          
          {/* Photos Section - Slideshow Only */}
          {activeSection === 'photos' && (
            <div>
              {/* Slideshow View Only */}
              <div className="max-w-4xl mx-auto">
                {filteredPhotos.length > 0 && (
                  <div className="relative bg-black rounded-lg overflow-hidden">
                    {/* Main Image */}
                    <div className="relative h-96 md:h-[500px]">
                      <img
                        src={filteredPhotos[currentSlide].src}
                        alt={filteredPhotos[currentSlide].alt}
                        className="w-full h-full object-cover object-center"
                      />
                      
                      {/* Navigation Arrows */}
                      <button
                        onClick={prevSlide}
                        className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white transition-all cursor-pointer"
                      >
                        <i className="ri-arrow-left-line text-xl"></i>
                      </button>
                      <button
                        onClick={nextSlide}
                        className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white transition-all cursor-pointer"
                      >
                        <i className="ri-arrow-right-line text-xl"></i>
                      </button>

                      {/* Play/Pause Button */}
                      <button
                        onClick={() => setIsPlaying(!isPlaying)}
                        className="absolute top-4 right-4 w-12 h-12 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white transition-all cursor-pointer"
                      >
                        <i className={`${isPlaying ? 'ri-pause-line' : 'ri-play-line'} text-xl`}></i>
                      </button>
                    </div>

                    {/* Slide Counter */}
                    <div className="absolute top-4 left-4 bg-black/50 text-white px-3 py-1 rounded-full text-sm">
                      {currentSlide + 1} / {filteredPhotos.length}
                    </div>
                  </div>
                )}

                {/* Thumbnail Navigation */}
                <div className="mt-6 flex justify-center">
                  <div className="flex gap-2 overflow-x-auto pb-2 max-w-full">
                    {filteredPhotos.map((photo, index) => (
                      <button
                        key={photo.id}
                        onClick={() => goToSlide(index)}
                        className={`flex-shrink-0 w-16 h-16 rounded-lg overflow-hidden border-2 transition-all cursor-pointer ${
                          index === currentSlide
                            ? 'border-orange-500 opacity-100'
                            : 'border-gray-300 opacity-60 hover:opacity-80'
                        }`}
                      >
                        <img
                          src={photo.src}
                          alt={photo.alt}
                          className="w-full h-full object-cover object-top"
                        />
                      </button>
                    ))}
                  </div>
                </div>

                {/* Progress Bar */}
                {isPlaying && (
                  <div className="mt-4 w-full bg-gray-200 rounded-full h-1">
                    <div 
                      className="bg-orange-500 h-1 rounded-full transition-all duration-100"
                      style={{
                        width: `${((currentSlide + 1) / filteredPhotos.length) * 100}%`
                      }}
                    ></div>
                  </div>
                )}

                {/* Controls Info */}
                <div className="mt-6 text-center text-gray-600 text-sm">
                  <p>
                    <i className="ri-information-line mr-1"></i>
                    Utilisez les flèches ou cliquez sur les miniatures pour naviguer
                    {isPlaying && ' • Défilement automatique activé'}
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* Videos Section */}
          {activeSection === 'videos' && (
            <div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {filteredVideos.map((video) => (
                  <div key={video.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow cursor-pointer">
                    {video.videoUrl ? (
                      <div className="relative">
                        <video 
                          controls 
                          className="w-full h-48 object-cover"
                          poster={video.thumbnail}
                        >
                          <source src={video.videoUrl} type="video/mp4" />
                          Votre navigateur ne supporte pas la lecture vidéo.
                        </video>
                      </div>
                    ) : (
                      <div className="relative">
                        <img
                          src={video.thumbnail}
                          alt={video.title}
                          className="w-full h-48 object-cover object-top"
                        />
                        <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center">
                          <div className="w-16 h-16 bg-white bg-opacity-90 rounded-full flex items-center justify-center">
                            <i className="ri-play-fill text-2xl text-orange-500"></i>
                          </div>
                        </div>
                        <div className="absolute bottom-2 right-2 bg-black bg-opacity-70 text-white px-2 py-1 rounded text-sm">
                          {video.duration}
                        </div>
                      </div>
                    )}
                    <div className="p-4">
                      <h3 className="font-semibold text-gray-900">{video.title}</h3>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Testimonials Section */}
          {activeSection === 'testimonials' && (
            <div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {testimonials.map((testimonial) => (
                  <div key={testimonial.id} className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow">
                    <div className="flex items-center mb-4">
                      <img
                        src={testimonial.avatar}
                        alt={testimonial.name}
                        className="w-12 h-12 rounded-full object-cover object-top mr-4"
                      />
                      <div>
                        <h4 className="font-semibold text-gray-900">{testimonial.name}</h4>
                        <p className="text-sm text-gray-600">{testimonial.role}</p>
                      </div>
                    </div>
                    <p className="text-gray-700 italic">"{testimonial.content}"</p>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Social Media Section */}
          {activeSection === 'social' && (
            <div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                
                {/* Instagram Feed */}
                <div className="bg-white rounded-lg shadow-md p-6">
                  <div className="flex items-center justify-between mb-6">
                    <div className="flex items-center gap-3">
                      <i className="ri-instagram-line text-2xl text-pink-500"></i>
                      <div>
                        <h3 className="text-xl font-bold text-gray-900">@ide_events</h3>
                        <p className="text-gray-600">Suivez nos événements en direct</p>
                      </div>
                    </div>
                    <a 
                      href="https://www.instagram.com/ide_events?utm_source=qr&igsh=ZXhud2dta2l3Yjlo" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="bg-pink-500 text-white px-4 py-2 rounded-full hover:bg-pink-600 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      Suivre
                    </a>
                  </div>
                  
                  <div className="grid grid-cols-3 gap-2 mb-4">
                    {[1, 2, 3, 4, 5, 6].map((i) => (
                      <div key={i} className="aspect-square bg-gray-100 rounded-lg overflow-hidden">
                        <img
                          src={`https://readdy.ai/api/search-image?query=Instagram%20post%20style%20image%20for%20African%20cultural%20events%2C%20square%20format%2C%20vibrant%20colors%2C%20social%20media%20aesthetic%2C%20professional%20event%20photography&width=200&height=200&seq=insta${i}&orientation=squarish`}
                          alt={`Post Instagram ${i}`}
                          className="w-full h-full object-cover object-top"
                        />
                      </div>
                    ))}
                  </div>
                  
                  <div className="flex justify-between text-sm text-gray-600">
                    <span>2.5k abonnés</span>
                    <span>156 publications</span>
                    <span>1.2k j'aime/mois</span>
                  </div>
                </div>

                {/* TikTok Feed */}
                <div className="bg-white rounded-lg shadow-md p-6">
                  <div className="flex items-center justify-between mb-6">
                    <div className="flex items-center gap-3">
                      <i className="ri-tiktok-line text-2xl text-black"></i>
                      <div>
                        <h3 className="text-xl font-bold text-gray-900">@ideroro2</h3>
                        <p className="text-gray-600">Contenus créatifs et tendances</p>
                      </div>
                    </div>
                    <a 
                      href="http://tiktok.com/@ideroro2" 
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-black text-white px-4 py-2 rounded-full hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      Suivre
                    </a>
                  </div>
                  
                  <div className="grid grid-cols-2 gap-3 mb-4">
                    {[1, 2, 3, 4].map((i) => (
                      <div key={i} className="aspect-[9/16] bg-gray-100 rounded-lg overflow-hidden relative">
                        <img
                          src={`https://readdy.ai/api/search-image?query=TikTok%20style%20vertical%20video%20thumbnail%20for%20African%20cultural%20events%2C%20mobile%20format%2C%20dynamic%20composition%2C%20social%20media%20aesthetic%2C%20engaging%20visual&width=180&height=320&seq=tiktok${i}&orientation=portrait`}
                          alt={`Vidéo TikTok ${i}`}
                          className="w-full h-full object-cover object-top"
                        />
                        <div className="absolute bottom-2 left-2 text-white text-xs bg-black bg-opacity-50 px-2 py-1 rounded">
                          <i className="ri-play-fill mr-1"></i>
                          {Math.floor(Math.random() * 50 + 10)}k
                        </div>
                      </div>
                    ))}
                  </div>
                  
                  <div className="flex justify-between text-sm text-gray-600">
                    <span>1.8k abonnés</span>
                    <span>42 vidéos</span>
                    <span>25k vues/mois</span>
                  </div>
                </div>
              </div>

              {/* Social Stats */}
              <div className="mt-12 bg-gradient-to-r from-orange-500 to-red-500 rounded-lg p-8 text-white">
                <h3 className="text-2xl font-bold text-center mb-8">Notre Impact Social</h3>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
                  <div>
                    <div className="text-3xl font-bold mb-2">4.3k</div>
                    <div className="text-sm opacity-90">Abonnés Total</div>
                  </div>
                  <div>
                    <div className="text-3xl font-bold mb-2">198</div>
                    <div className="text-sm opacity-90">Publications</div>
                  </div>
                  <div>
                    <div className="text-3xl font-bold mb-2">75k</div>
                    <div className="text-sm opacity-90">Vues Mensuelles</div>
                  </div>
                  <div>
                    <div className="text-3xl font-bold mb-2">92%</div>
                    <div className="text-sm opacity-90">Engagement</div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Gallery;
